import {
    SOLUTION_GROUP_FORM,
    FORM_FIELD_SG_NAME,
    FORM_FIELD_SG_ACTIVE,
    FORM_FIELD_SG_COUNTRIES,
} from './formConstants';

export const editReqFields = {
    'DEFAULT': {
        'EDITOR': {
            [SOLUTION_GROUP_FORM]: [
                FORM_FIELD_SG_NAME,
            ],
        }
    },
};

export const createReqFields = {
    'DEFAULT': {
        [SOLUTION_GROUP_FORM]: [
            FORM_FIELD_SG_NAME,
        ],
    }
};

